import { useSelector } from 'react-redux';

import { useQuery } from '@tanstack/react-query';
import { isEqual } from 'lodash-es';

import * as ScenarioStore from '@asteria/datalayer/stores/scenarios';

export function useForecastActionsQuery({ onSubmit, enabled }) {
	const sourceScenario = useSelector(
		ScenarioStore.selectors.scenario,
		isEqual,
	);

	const response = useQuery({
		queryKey: ['forecaster', 'actions', sourceScenario],
		queryFn: async () => onSubmit?.('forecast:actions:fetch'),
		refetchOnMount: true,
		enabled: enabled,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		placeholderData: null,
		cacheTime: 0,
		staleTime: 0,
	});

	return response;
}
